// Configuración de campos por tipo de documento
export const CAMPOS_POR_TIPO = {
	HOJA_DE_VISITA: [
		{ type: 'section', label: 'DATOS DEL CLIENTE' },
		{
			name: 'nombreCompletoCliente',
			label: 'Nombre Completo',
			type: 'text',
		},
		{
			name: 'identificadorCliente',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{ name: 'telefonoCliente', label: 'Teléfono', type: 'text' },

		{ type: 'section', label: 'DATOS DEL INMUEBLE' },
		{
			name: 'ubicacionInmueble',
			label: 'Ubicación',
			type: 'text',
		},
		{ name: 'localidadInmueble', label: 'Localidad', type: 'text' },
		{ name: 'habitacionesInmueble', label: 'Habitaciones', type: 'text' },
		{ name: 'bathroomsInmueble', label: 'Baños', type: 'text' },
		{ name: 'superficieInmueble', label: 'Superficie (m²)', type: 'text' },
		{ name: 'yearInmueble', label: 'Año de Construcción', type: 'text' },
		{ name: 'cocinaInmueble', label: 'Cocina', type: 'text' },
		{ name: 'valoracionInmueble', label: 'Valoración', type: 'text' },
		{ name: 'ibiInmueble', label: 'IBI', type: 'text' },
		{ name: 'comunidadInmueble', label: 'Comunidad', type: 'text' },
		{ name: 'vpoInmueble', label: 'VPO', type: 'text' },

		{ type: 'section', label: 'HONORARIOS Y FECHA' },
		{ name: 'honorarios', label: 'Honorarios', type: 'text' },
		{ name: 'dia', label: 'Día', type: 'text' },
		{ name: 'mes', label: 'Mes', type: 'text' },
		{ name: 'year', label: 'Año', type: 'text' },
	],
	COMPROMISO_DE_VENTA: [
		{ type: 'section', label: 'CLIENTE 1 (VENDEDOR)' },
		{ name: 'nombreCliente', label: 'Nombre Completo', type: 'text' },
		{
			name: 'identificacionCliente',
			label: 'Identificación (DNI/NIE)',
			type: 'text',
		},
		{
			name: 'ubicacionCliente',
			label: 'Ubicación/Domicilio',
			type: 'text',
		},
		{
			name: 'localidadCliente',
			label: 'Localidad',
			type: 'text',
		},
		{ name: 'cpCliente', label: 'Código Postal', type: 'text' },
		{
			name: 'telefonoCliente',
			label: 'Teléfono',
			type: 'text',
		},
		{ name: 'emailCliente', label: 'Email', type: 'text' },
		{
			name: 'enSuNombreSi',
			label: 'Actúa en su nombre (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNo',
			label: 'Actúa en representación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'representandoCliente',
			label: 'Representando a',
			type: 'text',
		},

		{ type: 'section', label: 'CLIENTE 2 (COMPRADOR) - Opcional' },
		{
			name: 'nombreClienteDos',
			label: 'Nombre Completo',
			type: 'text',
		},
		{
			name: 'identificadorClienteDos',
			label: 'Identificación (DNI/NIE)',
			type: 'text',
		},
		{
			name: 'domicilioClienteDos',
			label: 'Domicilio',
			type: 'text',
		},
		{
			name: 'cpClienteDos',
			label: 'Código Postal',
			type: 'text',
		},
		{
			name: 'telefonoClienteDos',
			label: 'Teléfono',
			type: 'text',
		},
		{ name: 'emailClienteDos', label: 'Email', type: 'text' },
		{
			name: 'enSuNombreSiDos',
			label: 'Actúa en su nombre (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNoDos',
			label: 'Actúa en representación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'representandoClienteDos',
			label: 'Representando a',
			type: 'text',
		},

		{ type: 'section', label: 'DATOS DEL INMUEBLE' },
		{
			name: 'ubicacionInmueble',
			label: 'Ubicación',
			type: 'text',
		},
		{
			name: 'catastroInmueble',
			label: 'Referencia Catastral',
			type: 'text',
		},
		{ name: 'cpInmueble', label: 'Código Postal', type: 'text' },
		{
			name: 'fincaInmueble',
			label: 'Finca/Registro',
			type: 'text',
		},
		{
			name: 'tipologiaInmueble',
			label: 'Tipología',
			type: 'text',
		},
		{ name: 'precioVentaInmueble', label: 'Precio de Venta', type: 'text' },

		{ type: 'section', label: 'HONORARIOS Y VALIDEZ' },
		{ name: 'honorarios', label: 'Honorarios', type: 'text' },
		{
			name: 'validezDiaStart',
			label: 'Validez - Día inicio',
			type: 'text',
		},
		{
			name: 'validezMesStart',
			label: 'Validez - Mes inicio',
			type: 'text',
		},
		{
			name: 'validezYearStart',
			label: 'Validez - Año inicio',
			type: 'text',
		},
		{ name: 'validezDiaEnd', label: 'Validez - Día fin', type: 'text' },
		{ name: 'validezMesEnd', label: 'Validez - Mes fin', type: 'text' },
		{ name: 'validezYearEnd', label: 'Validez - Año fin', type: 'text' },

		{ type: 'section', label: 'INFORMACIÓN ADICIONAL' },
		{
			name: 'cargasInmueble',
			label: 'Cargas del Inmueble',
			type: 'textarea',
		},
		{ name: 'condicionesInmueble', label: 'Condiciones', type: 'textarea' },
		{
			name: 'observacionesInmueble',
			label: 'Observaciones (línea 1)',
			type: 'textarea',
		},
		{
			name: 'observacionesInmuebleDos',
			label: 'Observaciones (línea 2)',
			type: 'textarea',
		},

		{ type: 'section', label: 'FECHA DE FIRMA' },
		{ name: 'dia', label: 'Día', type: 'text' },
		{ name: 'mes', label: 'Mes', type: 'text' },
		{ name: 'year', label: 'Año', type: 'text' },
	],
	ANEXO_COMPROMISO_DE_VENTA: [
		{ type: 'section', label: 'CLIENTE 1' },
		{
			name: 'nombreCompletoCliente',
			label: 'Nombre Completo',
			type: 'text',
		},
		{
			name: 'identificadorCliente',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{
			name: 'domicilioCliente',
			label: 'Domicilio',
			type: 'text',
		},
		{
			name: 'telefonoCliente',
			label: 'Teléfono',
			type: 'text',
		},
		{ name: 'emailCliente', label: 'Email', type: 'text' },
		{
			name: 'enSuNombreSi',
			label: 'Actúa en su nombre (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNo',
			label: 'Actúa en representación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'representadoCliente',
			label: 'Representado por',
			type: 'text',
		},

		{ type: 'section', label: 'CLIENTE 2 - Opcional' },
		{
			name: 'nombreCompletoClienteDos',
			label: 'Nombre Completo',
			type: 'text',
		},
		{
			name: 'identificadorClienteDos',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{
			name: 'domicilioClienteDos',
			label: 'Domicilio',
			type: 'text',
		},
		{
			name: 'telefonoClienteDos',
			label: 'Teléfono',
			type: 'text',
		},
		{ name: 'emailClienteDos', label: 'Email', type: 'text' },
		{
			name: 'enSuNombreSiDos',
			label: 'Actúa en su nombre (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNoDos',
			label: 'Actúa en representación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'representadoClienteDos',
			label: 'Representado por',
			type: 'text',
		},

		{ type: 'section', label: 'CLIENTE 3 - Opcional' },
		{
			name: 'nombreCompletoClienteTres',
			label: 'Nombre Completo',
			type: 'text',
		},
		{
			name: 'identificadorClienteTres',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{
			name: 'domicilioClienteTres',
			label: 'Domicilio',
			type: 'text',
		},
		{
			name: 'telefonoClienteTres',
			label: 'Teléfono',
			type: 'text',
		},
		{ name: 'emailClienteTres', label: 'Email', type: 'text' },
		{
			name: 'enSuNombreSiTres',
			label: 'Actúa en su nombre (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNoTres',
			label: 'Actúa en representación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'representadoClienteTres',
			label: 'Representado por',
			type: 'text',
		},

		{ type: 'section', label: 'CLIENTE 4 - Opcional' },
		{
			name: 'nombreCompletoClienteCuatro',
			label: 'Nombre Completo',
			type: 'text',
		},
		{
			name: 'identificadorClienteCuatro',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{
			name: 'domicilioClienteCuatro',
			label: 'Domicilio',
			type: 'text',
		},
		{
			name: 'telefonoClienteCuatro',
			label: 'Teléfono',
			type: 'text',
		},
		{
			name: 'emailClienteCuatro',
			label: 'Email',
			type: 'text',
		},
		{
			name: 'enSuNombreSiCuatro',
			label: 'Actúa en su nombre (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNoCuatro',
			label: 'Actúa en representación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'representadoClienteCuatro',
			label: 'Representado por',
			type: 'text',
		},

		{ type: 'section', label: 'DATOS DEL INMUEBLE' },
		{
			name: 'ubicacionInmueble',
			label: 'Ubicación',
			type: 'text',
		},
		{ name: 'localidadInmueble', label: 'Localidad', type: 'text' },

		{ type: 'section', label: 'VIGENCIA DEL CONTRATO' },
		{
			name: 'diaVigenciaContrato',
			label: 'Día',
			type: 'text',
		},
		{
			name: 'mesVigenciaContrato',
			label: 'Mes',
			type: 'text',
		},
		{
			name: 'yearVigenciaContrato',
			label: 'Año',
			type: 'text',
		},
	],
	CONTRATOINTERMEDACIONWOLFIN: [
		{ type: 'section', label: 'CLIENTE 1' },
		{ name: 'nombreCliente', label: 'Nombre Completo', type: 'text' },
		{
			name: 'identidicadorCliente',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{
			name: 'nacionalidadCliente',
			label: 'Nacionalidad',
			type: 'text',
		},
		{
			name: 'ubicacionCliente',
			label: 'Ubicación/Domicilio',
			type: 'text',
		},
		{ name: 'cpCliente', label: 'Código Postal', type: 'text' },
		{
			name: 'telefonoCliente',
			label: 'Teléfono',
			type: 'text',
		},
		{
			name: 'telefonoDosCliente',
			label: 'Teléfono 2 (opcional)',
			type: 'text',
		},
		{ name: 'emailCliente', label: 'Email', type: 'text' },

		{ type: 'section', label: 'CLIENTE 2 - Opcional' },
		{
			name: 'nombreClienteDos',
			label: 'Nombre Completo',
			type: 'text',
		},
		{
			name: 'identificadorClienteDos',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{
			name: 'nacionalidadClienteDos',
			label: 'Nacionalidad',
			type: 'text',
		},
		{
			name: 'ubicacionClienteDos',
			label: 'Ubicación/Domicilio',
			type: 'text',
		},
		{
			name: 'cpClienteDos',
			label: 'Código Postal',
			type: 'text',
		},
		{
			name: 'telefonoClienteDos',
			label: 'Teléfono',
			type: 'text',
		},
		{
			name: 'telefonoDosClienteDos',
			label: 'Teléfono 2',
			type: 'text',
		},
		{ name: 'emailClienteDos', label: 'Email', type: 'text' },

		{ type: 'section', label: 'REPRESENTACIÓN' },
		{
			name: 'c1enSuNombre',
			label: 'Cliente 1 - Actúa en su nombre (marcar)',
			type: 'checkbox',
		},
		{
			name: 'c2enSuNombre',
			label: 'Cliente 2 - Actúa en su nombre (marcar)',
			type: 'checkbox',
		},
		{
			name: 'c1Representando',
			label: 'Cliente 1 - Actúa en representación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'c2Representando',
			label: 'Cliente 2 - Actúa en representación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'clienteRepresentado',
			label: 'Nombre del representado',
			type: 'text',
		},
		{
			name: 'domicilio',
			label: 'Domicilio del representado',
			type: 'text',
		},
		{
			name: 'identificador',
			label: 'Identificador del representado',
			type: 'text',
		},
		{ name: 'enCalidadDe', label: 'En calidad de', type: 'text' },

		{ type: 'section', label: 'SERVICIO SOLICITADO' },
		{ name: 'tipoServicio', label: 'Tipo de servicio', type: 'text' },
		{
			name: 'plazoAmortizacion',
			label: 'Plazo amortización',
			type: 'text',
		},
		{ name: 'importePrestamo', label: 'Importe préstamo', type: 'text' },
		{ name: 'tipoInteres', label: 'Tipo de interés', type: 'text' },
		{ name: 'otros', label: 'Otros', type: 'textarea' },

		{ type: 'section', label: 'HONORARIOS Y OBSERVACIONES' },
		{ name: 'honorarios', label: 'Honorarios', type: 'text' },
		{
			name: 'observacionesPuntoSeis',
			label: 'Observaciones punto 6',
			type: 'textarea',
		},
		{
			name: 'casillaDosPuntoSeis',
			label: 'Casilla 2 punto 6',
			type: 'text',
		},
		{
			name: 'casillaTresPuntoSeis',
			label: 'Casilla 3 punto 6',
			type: 'text',
		},

		{ type: 'section', label: 'CLÁUSULA 14' },
		{
			name: 'lineaUnoPuntoCatorce',
			label: 'Línea 1',
			type: 'textarea',
		},
		{
			name: 'lineaDosPuntoCatorce',
			label: 'Línea 2',
			type: 'textarea',
		},
		{
			name: 'lineaTresPuntoCatorce',
			label: 'Línea 3',
			type: 'textarea',
		},
		{
			name: 'lineaCuatroPuntoCatorce',
			label: 'Línea 4',
			type: 'textarea',
		},

		{ type: 'section', label: 'FECHA Y LUGAR' },
		{ name: 'localidadInmueble', label: 'Localidad', type: 'text' },
		{ name: 'dia', label: 'Día', type: 'text' },
		{ name: 'mes', label: 'Mes', type: 'text' },
		{ name: 'year', label: 'Año', type: 'text' },
	],
	DECLARACION_DE_COMISION: [
		{ type: 'section', label: 'CLIENTE 1' },
		{ name: 'nombreCliente', label: 'Nombre', type: 'text' },
		{
			name: 'ubicacionCliente',
			label: 'Ubicación/Domicilio',
			type: 'text',
		},
		{ name: 'localidadCliente', label: 'Localidad', type: 'text' },
		{
			name: 'identificadorCliente',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{ name: 'telefonoCliente', label: 'Teléfono', type: 'text' },
		{ name: 'emailCliente', label: 'Email', type: 'text' },
		{
			name: 'enSuNombreSi',
			label: 'En su nombre: Sí (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNo',
			label: 'En su nombre: No (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enRepresentacion',
			label: 'En representación de',
			type: 'text',
		},

		{ type: 'section', label: 'CLIENTE 2 (OPCIONAL)' },
		{ name: 'nombreClienteDos', label: 'Nombre', type: 'text' },
		{ name: 'ubicacionClienteDos', label: 'Ubicación', type: 'text' },
		{ name: 'localidadClienteDos', label: 'Localidad', type: 'text' },
		{
			name: 'identificadorClienteDos',
			label: 'Identificador',
			type: 'text',
		},
		{ name: 'telefonoClienteDos', label: 'Teléfono', type: 'text' },
		{ name: 'emailClienteDos', label: 'Email', type: 'text' },
		{
			name: 'enSuNombreSiDos',
			label: 'En su nombre: Sí (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNoDos',
			label: 'En su nombre: No (marcar)',
			type: 'checkbox',
		},
		{
			name: 'enRepresentacionClienteDos',
			label: 'En representación de',
			type: 'text',
		},

		{ type: 'section', label: 'DATOS DEL INMUEBLE' },
		{ name: 'ubicacionInmueble', label: 'Ubicación', type: 'text' },
		{ name: 'localidadInmueble', label: 'Localidad', type: 'text' },
		{ name: 'cpInmueble', label: 'Código Postal', type: 'text' },
		{
			name: 'catastroInmueble',
			label: 'Referencia Catastral',
			type: 'text',
		},
		{ name: 'fincaInmueble', label: 'Finca/Registro', type: 'text' },
		{
			name: 'descripcionInmueble',
			label: 'Descripción',
			type: 'textarea',
		},

		{ type: 'section', label: 'HONORARIOS Y FECHA' },
		{ name: 'honorarios', label: 'Honorarios', type: 'text' },
		{ name: 'honorariosWolfin', label: 'Honorarios Wolfin', type: 'text' },
		{ name: 'dia', label: 'Día', type: 'text' },
		{ name: 'mes', label: 'Mes', type: 'text' },
		{ name: 'year', label: 'Año', type: 'text' },
	],
	GASTOS_VENDEDOR: [
		{ type: 'section', label: 'GASTOS HIPOTECARIOS' },
		{
			name: 'hipotecaPendienteInmueble',
			label: 'Hipoteca pendiente',
			type: 'text',
		},
		{ name: 'gastosNotaria', label: 'Gastos de notaría', type: 'text' },
		{ name: 'plusvalia', label: 'Plusvalía', type: 'text' },

		{ type: 'section', label: 'COMISIÓN CANCELACIÓN ANTICIPADA' },
		{
			name: 'comisionCancelacion0',
			label: '0% (marcar)',
			type: 'checkbox',
		},
		{
			name: 'comisionCancelacion05',
			label: '0.5% (marcar)',
			type: 'checkbox',
		},
		{
			name: 'comisionCancelacion1',
			label: '1% (marcar)',
			type: 'checkbox',
		},
		{
			name: 'comisionCancelacion15',
			label: '1.5% (marcar)',
			type: 'checkbox',
		},
		{
			name: 'comisionCancelacion2',
			label: '2% (marcar)',
			type: 'checkbox',
		},

		{ type: 'section', label: 'OTROS GASTOS' },
		{
			name: 'gastosCancelacionRegistral',
			label: 'Gastos cancelación registral',
			type: 'text',
		},
		{ name: 'gastosHacienda', label: 'Gastos de hacienda', type: 'text' },
		{
			name: 'certificadoEnergetico',
			label: 'Certificado energético',
			type: 'text',
		},
		{
			name: 'gastosInmobiliaria',
			label: 'Gastos inmobiliaria/comisión',
			type: 'text',
		},

		{ type: 'section', label: 'DEUDAS' },
		{
			name: 'deudasDeContribucion',
			label: 'Deudas de contribución',
			type: 'text',
		},
		{
			name: 'deudasDeComunidad',
			label: 'Deudas de comunidad',
			type: 'text',
		},
		{ name: 'deudasFinca', label: 'Deudas de finca', type: 'text' },

		{ type: 'section', label: 'TOTALES Y FECHA' },
		{ name: 'totalGasto', label: 'Total gasto', type: 'text' },
		{ name: 'totalBeneficio', label: 'Total beneficio', type: 'text' },
		{ name: 'localidad', label: 'Localidad', type: 'text' },
		{ name: 'dia', label: 'Día', type: 'text' },
		{ name: 'mes', label: 'Mes', type: 'text' },
		{ name: 'year', label: 'Año', type: 'text' },
	],
	GASTOS_COMPRADOR: [
		{ type: 'section', label: 'CLIENTE 1' },
		{ name: 'nombreCliente', label: 'Nombre', type: 'text' },
		{
			name: 'identificadorCliente',
			label: 'Identificador (DNI/NIE)',
			type: 'text',
		},
		{ name: 'telefonoCliente', label: 'Teléfono', type: 'text' },
		{
			name: 'ubicacionCliente',
			label: 'Ubicación/Domicilio',
			type: 'text',
		},
		{ name: 'localidadCliente', label: 'Localidad', type: 'text' },

		{ type: 'section', label: 'CLIENTE 2 (OPCIONAL)' },
		{ name: 'nombreClienteDos', label: 'Nombre', type: 'text' },
		{
			name: 'identificadorClienteDos',
			label: 'Identificador',
			type: 'text',
		},
		{ name: 'telefonoClienteDos', label: 'Teléfono', type: 'text' },
		{ name: 'ubicacionClienteDos', label: 'Ubicación', type: 'text' },
		{ name: 'localidadClienteDos', label: 'Localidad', type: 'text' },

		{ type: 'section', label: 'INFORMACIÓN GENERAL' },
		{
			name: 'primeraVivienda',
			label: '¿Primera vivienda? (Sí/No)',
			type: 'text',
		},
		{
			name: 'tienePropiedad',
			label: '¿Tiene propiedad? (Sí/No)',
			type: 'text',
		},
		{ name: 'estadoCivil', label: 'Estado civil', type: 'text' },
		{ name: 'numeroTitulares', label: 'Número de titulares', type: 'text' },
		{ name: 'edadTitulares', label: 'Edad de titulares', type: 'text' },
		{
			name: 'familiaNumerosa',
			label: 'Familia numerosa (Sí/No)',
			type: 'text',
		},

		{ type: 'section', label: 'GASTOS HIPOTECARIOS' },
		{ name: 'tipoDeHipoteca', label: 'Tipo de hipoteca', type: 'text' },
		{ name: 'aportacion', label: 'Aportación', type: 'text' },
		{ name: 'plazo', label: 'Plazo (años)', type: 'text' },
		{ name: 'cuota', label: 'Cuota mensual', type: 'text' },
		{
			name: 'comisionApertura',
			label: 'Comisión de apertura',
			type: 'text',
		},

		{ type: 'section', label: 'GASTOS ADICIONALES' },
		{ name: 'gastosNotaria', label: 'Gastos de notaría', type: 'text' },
		{ name: 'gastosGestoria', label: 'Gastos de gestoría', type: 'text' },
		{ name: 'gastosRegistro', label: 'Gastos de registro', type: 'text' },
		{ name: 'tasacion', label: 'Tasación', type: 'text' },
		{ name: 'finacieraWolfin', label: 'Financiera Wolfin', type: 'text' },
		{ name: 'gastosHacienda', label: 'Gastos de hacienda', type: 'text' },
		{
			name: 'gastosInmobiliria',
			label: 'Gastos inmobiliaria',
			type: 'text',
		},

		{ type: 'section', label: 'DEUDAS' },
		{ name: 'deudasCliente', label: 'Deudas del cliente', type: 'text' },
	],
	PROPUESTA_DE_COMPRAVENTA: [
		{ type: 'section', label: 'CLIENTE 1' },
		{ name: 'nombreCliente', label: 'Nombre', type: 'text' },
		{ name: 'ubicacionCliente', label: 'Ubicación', type: 'text' },
		{ name: 'localidadCliente', label: 'Localidad', type: 'text' },
		{ name: 'telefonoCliente', label: 'Teléfono', type: 'text' },
		{ name: 'emailCliente', label: 'Email', type: 'text' },
		{ name: 'identificadorCliente', label: 'DNI/NIE', type: 'text' },
		{ name: 'enSuNombreSi', label: 'En su nombre (Sí)', type: 'checkbox' },
		{ name: 'enSuNombreNo', label: 'En su nombre (No)', type: 'checkbox' },
		{
			name: 'representandoCliente',
			label: 'Representando a',
			type: 'text',
		},

		{ type: 'section', label: 'CLIENTE 2 (OPCIONAL)' },
		{ name: 'nombreClienteDos', label: 'Nombre', type: 'text' },
		{ name: 'ubicacionClienteDos', label: 'Ubicación', type: 'text' },
		{ name: 'localidadClienteDos', label: 'Localidad', type: 'text' },
		{ name: 'telefonoClienteDos', label: 'Teléfono', type: 'text' },
		{ name: 'emailClienteDos', label: 'Email', type: 'text' },
		{ name: 'identificadorClienteDos', label: 'DNI/NIE', type: 'text' },
		{
			name: 'enSuNombreSiClienteDos',
			label: 'En su nombre (Sí)',
			type: 'checkbox',
		},
		{
			name: 'enSuNombreNoClienteDos',
			label: 'En su nombre (No)',
			type: 'checkbox',
		},
		{
			name: 'representandoClienteDos',
			label: 'Representando a',
			type: 'text',
		},

		{ type: 'section', label: 'DATOS DEL INMUEBLE' },
		{ name: 'ubicacionInmueble', label: 'Dirección', type: 'text' },
		{ name: 'localidadInmueble', label: 'Localidad', type: 'text' },
		{
			name: 'catastroInmueble',
			label: 'Referencia Catastral',
			type: 'text',
		},
		{ name: 'cpInmueble', label: 'CP', type: 'text' },
		{ name: 'fincaInmueble', label: 'Finca', type: 'text' },
		{ name: 'tipologiaInmueble', label: 'Tipología', type: 'text' },

		{ type: 'section', label: 'CONDICIONES DE COMPRAVENTA' },
		{
			name: 'precioCompraventaPropuestoComprador',
			label: 'Precio Propuesto',
			type: 'text',
		},
		{ name: 'entrega4A', label: 'Entrega 4A', type: 'text' },
		{ name: 'entrega4B', label: 'Entrega 4B', type: 'text' },
		{ name: 'entrega4C', label: 'Entrega 4C', type: 'text' },
		{
			name: 'firmaContratoAntesDelDia',
			label: 'Firma antes del día',
			type: 'text',
		},
		{
			name: 'firmaContratoAntesDelMes',
			label: 'Firma antes del mes',
			type: 'text',
		},
		{
			name: 'firmaContratoAntesDelYear',
			label: 'Firma antes del año',
			type: 'text',
		},
		{
			name: 'compraventaFinanciacion',
			label: 'Financiación (marcar)',
			type: 'checkbox',
		},
		{
			name: 'compraventaContado',
			label: 'Contado (marcar)',
			type: 'checkbox',
		},
		{
			name: 'condicionesVivienda',
			label: 'Condiciones de la vivienda',
			type: 'text',
		},

		{ type: 'section', label: 'FECHA Y RESPUESTA' },
		{ name: 'dia', label: 'Día', type: 'text' },
		{ name: 'mes', label: 'Mes', type: 'text' },
		{ name: 'year', label: 'Año', type: 'text' },
		{ name: 'acepta', label: 'Acepta (marcar)', type: 'checkbox' },
		{ name: 'noAcepta', label: 'No acepta (marcar)', type: 'checkbox' },
	],
	RECISION_DE_CONTRATO: [
		{ type: 'section', label: 'DATOS DEL CLIENTE' },
		{ name: 'nombreCliente', label: 'Nombre', type: 'text' },
		{ name: 'identificadorCliente', label: 'DNI/NIE', type: 'text' },

		{ type: 'section', label: 'DATOS DEL INMUEBLE' },
		{ name: 'ubicacionInmueble', label: 'Dirección', type: 'text' },
		{ name: 'localidadInmueble', label: 'Localidad', type: 'text' },
		{ name: 'ciudadInmueble', label: 'Ciudad', type: 'text' },

		{ type: 'section', label: 'FECHA Y LOCALIDAD' },
		{ name: 'localidad', label: 'Localidad', type: 'text' },
		{ name: 'dia', label: 'Día', type: 'text' },
		{ name: 'mes', label: 'Mes', type: 'text' },
		{ name: 'year', label: 'Año', type: 'text' },
	],
	RECONOCIMIENTO_DE_HONORARIOS: [
		{ type: 'section', label: 'CLIENTE 1' },
		{ name: 'nombreCliente', label: 'Nombre', type: 'text' },
		{ name: 'identificadorCliente', label: 'DNI/NIE', type: 'text' },
		{ name: 'localidadCliente', label: 'Localidad', type: 'text' },
		{ name: 'municipioCliente', label: 'Municipio', type: 'text' },
		{ name: 'ciudadCliente', label: 'Ciudad', type: 'text' },

		{ type: 'section', label: 'CLIENTE 2 (OPCIONAL)' },
		{ name: 'nombreClienteDos', label: 'Nombre', type: 'text' },
		{ name: 'identificadorClienteDos', label: 'DNI/NIE', type: 'text' },
		{ name: 'ubicacionClienteDos', label: 'Ubicación', type: 'text' },
		{
			name: 'nUbicacionClienteDos',
			label: 'Número Ubicación',
			type: 'text',
		},
		{ name: 'localidadClienteDos', label: 'Localidad', type: 'text' },

		{ type: 'section', label: 'HONORARIOS E INMUEBLE' },
		{ name: 'honorarios', label: 'Honorarios', type: 'text' },
		{
			name: 'precioVentaInmueble',
			label: 'Precio Venta Inmueble',
			type: 'text',
		},
		{
			name: 'localidadInmueble',
			label: 'Localidad Inmueble',
			type: 'text',
		},

		{ type: 'section', label: 'FECHA' },
		{ name: 'dia', label: 'Día', type: 'text' },
		{ name: 'mes', label: 'Mes', type: 'text' },
		{ name: 'year', label: 'Año', type: 'text' },
	],
};
